import { defineMessages } from 'react-intl';

export default defineMessages({
  goaltending: {
    id: 'events.matchup.goaltending',
    defaultMessage: 'Goaltending',
    description: 'Title for Goaltending key players card',
  },
  keyPlayers: {
    id: 'events.matchup.key_players',
    defaultMessage: 'Key Players',
    description: 'Title for Key Players section',
  },
  scoringSummary: {
    id: 'events.matchup.scoring_summary',
    defaultMessage: 'Scoring Summary',
    description: 'Title for Scoring Summary section',
  },
  penaltySummary: {
    id: 'events.matchup.penalty_summary',
    defaultMessage: 'Penalty Summary',
    description: 'Title for Penalty Summary section',
  },
  threeStars: {
    id: 'events.matchup.three_stars',
    defaultMessage: '3 Stars',
    description: 'Title for three stars component',
  },
  teamStats: {
    id: 'events.matchup.team_stats',
    defaultMessage: 'Team Stats',
    description: 'Title for Team Stats component',
  },
  shootout: {
    id: 'events.matchup.shootout',
    defaultMessage: 'Shootout',
    description: 'Title for shootut component',
  },
  offensiveStats: {
    id: 'events.matchup.offensive_stats',
    defaultMessage: 'Offensive Stats (per game)',
    description: 'Title for Offensive Stats',
  },
  defensiveStats: {
    id: 'events.matchup.defensive_stats',
    defaultMessage: 'Defensive Stats (per game)',
    description: 'Title for Defensive Stats',
  },
  shotsOnGoal: {
    id: 'events.matchup.shots_on_goal',
    defaultMessage: 'Shots on Goal',
    description: 'Title for Shots on Goal component',
  },
  goals: {
    id: 'events.matchup.goals',
    defaultMessage: 'Goals',
  },
  cards: {
    id: 'events.matchup.cards',
    defaultMessage: 'Cards',
  },
  substitutions: {
    id: 'events.matchups.substitutions',
    defaultMessage: 'Substitutions',
  },
  missed_penalties: {
    id: 'events.matchup.missed_penalties',
    defaultMessage: 'Missed Penalties',
  },
  top_performers: {
    id: 'events.matchup.top_performers',
    defaultMessage: 'Top Performers',
  },
});
